// extracted by mini-css-extract-plugin
export default {"container":"LoadingComponent_container__wWWLr"};